import PromotionScope from './Disbursement';

export default PromotionScope;
